import HTTPS_AXIOS from '@/config/http'
import baseURL from '@/config/index'

// 客服登录
export function serviceLogin (datas) {
  const url = `${baseURL.imUrl}/imInterface/customerLogin`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js